class estadistics_2 {
  constructor(
    CCQuantity,
    authorizedQuantity,
    liquidatedQuantity,
    unauthorizedQuantity,
    idConcept,
    name,
    unit
  ) {
    this.CCQuantity = CCQuantity;
    this.authorizedQuantity = authorizedQuantity;
    this.liquidatedQuantity = liquidatedQuantity;
    this.unauthorizedQuantity = unauthorizedQuantity;
    this.idConcept = idConcept;
    this.name = name;
    this.unit = unit;
  }
  static fromJson({
    CantCC,
    CantAut,
    CantLiq,
    CantNoAut,
    ConceptoId,
    Nombre,
    unidad,
  }) {
    return new estadistics_2(
      CantCC,
      CantAut,
      CantLiq,
      CantNoAut,
      ConceptoId,
      Nombre,
      unidad
    );
  }
}
export default estadistics_2;
